/* eslint-disable no-param-reassign */
/* eslint-disable no-nested-ternary */
import { any, array, func, number, object, string } from "prop-types";
import React, { useState } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Spinner from "../Spinner";
import { postDrivingAssessment } from "../../api/profileApi";
import Button from "../Button";

import * as style from "./styles.module.scss";

const AssessmentCreator = ({
  appData,
  questions,
  scale = ["A", "B", "C", "D"],
  submittedFlagFunc,
  passedFlagFunc,
  passMark,
  assessmentName,
  retakeLink,
  testTitle,
}) => {
  const calculateSectionLengths = (questionsArr) =>
    questionsArr
      .reduce((sections, question) => {
        if (question.sectionTitle || question === questionsArr[0]) {
          return [[], ...sections];
        }
        const [lastSection, ...remaining] = sections;
        return [[question, ...lastSection], ...remaining];
      }, [])
      .reverse()
      .map((section) => section.length);

  const numberOfQuestionsPerSection = calculateSectionLengths(questions);

  const numberOfSections = numberOfQuestionsPerSection.length || 0;

  const [curSectNumber, setCurSectNumber] = useState(0);
  const [curQNumber, setCurQNumber] = useState(0);
  const [answers, setAnswer] = useState({});
  const [chosen, setChosen] = useState("");
  const [res, setRes] = useState(-1);
  const [loading, setLoading] = useState(false);

  const nextQuestion = () => {
    const next = curQNumber + 1;
    setCurQNumber(next);
    setChosen(answers[next - (numberOfSections ? curSectNumber + 1 : 0)] || ""); // if sections are present then curQnumber alone won't reflect correct key 'value' number for answers object
  };

  const previousQuestion = () => {
    const previous = curQNumber - 1;
    setCurQNumber(previous);
    setChosen(
      answers[previous - (numberOfSections ? curSectNumber + 1 : 0)] || ""
    );
  };

  const storeAnswer = (questionNumber, chosenAnswer) => {
    setChosen(chosenAnswer);
    setAnswer({ ...answers, [questionNumber - 1]: chosenAnswer });
  };

  const checkChosen = () => {
    if (chosen === "") {
      return false;
    }
    return true;
  };

  const loadChosen = () => {
    setChosen(answers[curQNumber]);
  };

  const submitTest = async () => {
    const result = await postDrivingAssessment(
      assessmentName,
      `${appData.firstName} ${appData.lastName}`,
      answers
    ).then((obj) => {
      const { data } = obj;
      return data;
    });
    const pass = result >= passMark;
    if (pass) await passedFlagFunc();
    setRes(result);
    return result;
  };

  const submitHandler = async () => {
    setLoading(true);
    await submittedFlagFunc();
    await submitTest();
    setLoading(false);
  };

  const populateAnswersAtoD = () => {
    return scale.map((curAns) => {
      return (
        <div
          className={style.answer}
          key={curAns}
          onClick={() =>
            storeAnswer(
              numberOfSections ? curQNumber - curSectNumber : curQNumber + 1,
              curAns
            )
          }
          style={chosen === curAns ? { border: "2px solid #ff6600" } : null}
        >
          <span>{`${curAns})`}</span>
          <span>
            <input
              type="radio"
              name="option"
              checked={chosen === curAns}
              value={curAns}
              onChange={(event) =>
                storeAnswer(
                  numberOfSections
                    ? curQNumber - curSectNumber
                    : curQNumber + 1,
                  event.target.value
                )
              }
            />
          </span>
          <span>{questions[curQNumber][curAns]}</span>
        </div>
      );
    });
  };

  const [secQNumber, setSecQNumber] = useState(0);

  const backButtons = () => {
    if (questions[curQNumber] === questions[0]) {
      return (
        // first question or section - go back to onboarding screen
        <Link
          style={{ textDecoration: "none" }}
          to="/profile/edit/driving-onboarding"
        >
          <Button classes="btn btn-block btn-outline-dark text-decoration-none">
            Back
          </Button>
        </Link>
      );
    }
    if (questions[curQNumber].sectionTitle) {
      return (
        // for section titles - change current section number
        <Button
          onClick={() => {
            previousQuestion();
            setCurSectNumber(
              curSectNumber !== 0 && numberOfSections ? curSectNumber - 1 : 0
            );
            setSecQNumber(
              curSectNumber !== 0
                ? numberOfQuestionsPerSection[curSectNumber - 1]
                : numberOfQuestionsPerSection[0]
            );
          }}
          classes="btn btn-block btn-outline-dark text-decoration-none"
        >
          Back
        </Button>
      );
    }
    return (
      // just go back to previous question
      <Button
        onClick={() => {
          loadChosen();
          previousQuestion();
          if (numberOfSections) {
            setSecQNumber(secQNumber - 1);
            if (questions[curQNumber - 1].sectionTitle) {
              setCurSectNumber(curSectNumber !== 0 ? curSectNumber - 1 : 0);
            }
          }
        }}
        classes="btn btn-block btn-outline-dark text-decoration-none"
      >
        Back
      </Button>
    );
  };

  const nextButtons = () => {
    if (curQNumber === questions.length - 1 && res === -1) {
      return (
        <Button
          disabled={loading || !checkChosen()}
          onClick={() => {
            submitHandler();
          }}
          id="btnBasicInfoEditSubmit"
          classes="btn btn-primary"
        >
          {loading ? <Spinner /> : "Submit"}
        </Button>
      );
    }
    if (curQNumber === questions.length - 1) {
      // feedback (last question)
      return (
        <Link
          style={{ textDecoration: "none" }}
          to={{
            pathname: "/profile/edit/driving-onboarding/assessment/feedback",
            state: {
              result: res,
              numQuestions: questions.length - numberOfSections,
              passed: res >= passMark,
              retakeLink,
              testTitle,
            },
          }}
        >
          <Button id="btnBasicInfoEditSubmit" classes="btn btn-primary">
            Results
          </Button>
        </Link>
      );
    }
    if (questions[curQNumber].sectionTitle) {
      // skip section title
      return (
        <Button
          onClick={() => {
            nextQuestion();
            setCurSectNumber(
              curQNumber !== 0 && numberOfSections ? curSectNumber + 1 : 0
            );
            setSecQNumber(1);
          }}
          id="btnBasicInfoEditSubmit"
          classes="btn btn-primary"
          style={{ width: "80px" }}
        >
          Next
        </Button>
      );
    }
    return (
      // next question only
      <Button
        disabled={!checkChosen()}
        onClick={() => {
          nextQuestion();
          if (numberOfSections) setSecQNumber(secQNumber + 1);
        }}
        id="btnBasicInfoEditSubmit"
        classes="btn btn-primary"
        style={{ width: "80px" }}
      >
        Next
      </Button>
    );
  };

  return (
    <div className="row justify-content-center" style={{ minHeight: "60vh" }}>
      <div className="col-sm-9 col-lg-8 p-2">
        <h2 className="section-header">{testTitle}</h2>
        <div>
          {questions[curQNumber].sectionTitle ? null : (
            <p className="mb-2 font-weight-bold" style={{ fontSize: "20px" }}>
              {`Question ${numberOfSections ? secQNumber : curQNumber + 1} / ${
                numberOfSections
                  ? numberOfQuestionsPerSection[curSectNumber]
                  : questions.length
              }`}
            </p>
          )}
          <section className="section-body p-1">
            {questions[curQNumber].question ? (
              <h4 className="styles__resource__title___3swKq text-left">
                {questions[curQNumber].question}
              </h4>
            ) : (
              questions[curQNumber].customQuestionComponent
            )}
            {questions[curQNumber].imgSrc &&
            questions[curQNumber].largeImage ? (
              <img
                className={style.largeImg}
                src={questions[curQNumber].imgSrc}
              />
            ) : null}
            <div
              style={{ display: "flex", flexDirection: "row", width: "100%" }}
            >
              {questions[curQNumber].sectionTitle ? (
                <div>
                  <h2>{questions[curQNumber].sectionTitle}</h2>
                  <p style={{ fontSize: "1.25em" }}>
                    {questions[curQNumber].sectionSubText}
                  </p>
                </div>
              ) : (
                <div className={style.answersContainer}>
                  {populateAnswersAtoD()}
                </div>
              )}
              {questions[curQNumber].imgSrc &&
              !questions[curQNumber].largeImage ? (
                <img className={style.img} src={questions[curQNumber].imgSrc} />
              ) : null}
            </div>
            <div className={style.container__buttons}>
              {backButtons()}
              {nextButtons()}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

AssessmentCreator.propTypes = {
  appData: any,
  questions: array.isRequired,
  scale: object,
  submittedFlagFunc: func.isRequired,
  passedFlagFunc: func.isRequired,
  passMark: number.isRequired,
  assessmentName: string.isRequired,
  retakeLink: string.isRequired,
  testTitle: string.isRequired,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, null);
export default withRedux(AssessmentCreator);
